export default __webpack_public_path__ + "static/failedImg-38e77a009bb5c59bfb12f4c28fce219e.png";